import { render, staticRenderFns } from "./FileUploaderWithProvider.vue?vue&type=template&id=a852c7f4&"
import script from "./FileUploaderWithProvider.vue?vue&type=script&lang=js&"
export * from "./FileUploaderWithProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports